/** Example payloads for Off-Ramp Check "Try example" CTAs. */

export const STITCH_EXAMPLE = [
    {
        id: 'mule_dr',
        dr_cr: 'Dr',
        account: 'MULE_A_50100',
        amount: 420000,
        ref_number: '412345678901',
        counterparty: 'seller@okhdfcbank',
    },
    {
        id: 'seller_cr',
        dr_cr: 'Cr',
        account: 'SELLER_B_88210',
        amount: 420000,
        ref_number: '412345678901',
        counterparty: 'MULE A',
    },
    {
        id: 'offramp_dr',
        dr_cr: 'Dr',
        account: 'MULE_A_50100',
        amount: 250000,
        ref_number: '998877665544',
        counterparty: 'wazirx@upi',
    },
];

export const STITCH_EXAMPLE_JSON = JSON.stringify(STITCH_EXAMPLE, null, 2);

export const TRIAGE_EXAMPLE = [
    {
        id: 'taint_cr',
        dr_cr: 'Cr',
        account: 'FROZEN_50100',
        amount: 50000,
        ref_number: '412345678901',
        counterparty: 'victim@okaxis',
        ts: '2026-01-10T09:00:00+05:30',
    },
    {
        id: 'salary_cr',
        dr_cr: 'Cr',
        account: 'FROZEN_50100',
        amount: 85000,
        ref_number: '512345678901',
        counterparty: 'employer@okhdfcbank',
        ts: '2026-01-11T09:00:00+05:30',
    },
    {
        id: 'rent_dr',
        dr_cr: 'Dr',
        account: 'FROZEN_50100',
        amount: 30000,
        ref_number: '612345678901',
        counterparty: 'landlord@ybl',
        ts: '2026-01-12T10:00:00+05:30',
    },
    {
        id: 'cashout_dr',
        dr_cr: 'Dr',
        account: 'FROZEN_50100',
        amount: 40000,
        ref_number: '712345678901',
        counterparty: 'otc@paytm',
        ts: '2026-01-12T11:00:00+05:30',
    },
];

export const TRIAGE_EXAMPLE_JSON = JSON.stringify(TRIAGE_EXAMPLE, null, 2);

export const SOF_EXAMPLE = [
    {
        id: 'c1',
        dr_cr: 'Cr',
        account: 'SELLER_88210',
        amount: 50000,
        ref_number: '111111111111',
        counterparty: 'a1@okaxis',
        ts: '2026-02-01T10:00:00+05:30',
    },
    {
        id: 'c2',
        dr_cr: 'Cr',
        account: 'SELLER_88210',
        amount: 50000,
        ref_number: '222222222222',
        counterparty: 'a2@okaxis',
        ts: '2026-02-01T10:05:00+05:30',
    },
    {
        id: 'c3',
        dr_cr: 'Cr',
        account: 'SELLER_88210',
        amount: 100000,
        ref_number: '333333333333',
        counterparty: 'a3@ybl',
        ts: '2026-02-01T10:10:00+05:30',
    },
    {
        id: 'c4',
        dr_cr: 'Cr',
        account: 'SELLER_88210',
        amount: 25000,
        ref_number: '444444444444',
        counterparty: 'a4@paytm',
        ts: '2026-02-01T10:15:00+05:30',
    },
    {
        id: 'c5',
        dr_cr: 'Cr',
        account: 'SELLER_88210',
        amount: 75000,
        ref_number: '555555555555',
        counterparty: 'a5@okhdfcbank',
        ts: '2026-02-01T10:20:00+05:30',
    },
    {
        id: 'd1',
        dr_cr: 'Dr',
        account: 'SELLER_88210',
        amount: 280000,
        ref_number: '666666666666',
        counterparty: 'wazirx deposit',
        ts: '2026-02-01T12:00:00+05:30',
    },
];

export const SOF_EXAMPLE_JSON = JSON.stringify(SOF_EXAMPLE, null, 2);

export const UTR_SAMPLE = 'HDFCR20260115000123456';
export const UTR_SAMPLE_LINE_DATE = '2026-01-20';

export const TRIAGE_DEFAULT_TAINTED_UTRS = '412345678901';
export const TRIAGE_DEFAULT_ACCOUNT = 'FROZEN_50100';
export const TRIAGE_DEFAULT_CLOSING = '65000';
export const SOF_DEFAULT_ACCOUNT = 'SELLER_88210';
